import { render, staticRenderFns } from "./EpochList.vue?vue&type=template&id=745579eb&"
import script from "./EpochList.vue?vue&type=script&lang=js&"
export * from "./EpochList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports